/* eslint-disable camelcase */
export type AccessToken = {
  access_token: string;
  expires_in: number;
  'not-before-policy': number;
  refresh_expires_in: number;
  refresh_token: string;
  scope: string;
  session_state: string;
  token_type: string;
};

export type SessionContextType = [true, string] | [false, null];

export enum AuthErrorCodes {
  EMAIL_NOT_CONFIRMED = 'EMAIL_NOT_CONFIRMED',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  NET_ERR = 'NET_ERR',
  UNKNOWN = 'UNKNOWN',
}

export type SessionEntityRequestHook<SessionEntity> = (accessToken: string) => [() => Promise<SessionEntity>, boolean];

export type LoginMutation = {
  username: string;
  password: string;
};
